import { Component } from '@angular/core';
import { soundpostReconFlowCategoryEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Recon Flow Categories') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostreconflowcategory-form',
    templateUrl: './soundpostreconflowcategory.form.component.html'
})
export class soundpostReconFlowCategoryFormComponent extends BaseFormComponent {
    public record!: soundpostReconFlowCategoryEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'orderLines', sectionName: 'Order Lines', isExpanded: false },
            { sectionKey: 'gLAccounts', sectionName: 'GL Accounts', isExpanded: false },
            { sectionKey: 'products', sectionName: 'Products', isExpanded: false },
            { sectionKey: 'reconFlowSnapshots', sectionName: 'Recon Flow Snapshots', isExpanded: false }
        ]);
    }
}

